Namespace 'Monitoring.Reports.Campaign'

class Monitoring.Reports.Campaign.PostClassifiedView extends Backbone.View

  className: 'post-classified'

  initialize: (@options = {}) =>
    @className = "contents-by-tags-post-classified" if @options.contentsByTag


  render: ->
    @$el.addClass('processing')

    if @options.post
      posts = @options.post.id
    else
      posts = _.map(@options.posts, (post) -> post.id)

    params = {
      account_id: @options.account_id,
      date_from_ISO: @options.date_from_ISO,
      date_to_ISO: @options.date_to_ISO,
      dimension: 'tags',
      ancestors: posts
    }

    $.post('/monitoring/api/charts/single_dimension', params, @_renderChart)

  _renderChart: (data) =>
    @serie = {
      classified: 0
      unclassified: 0
    }
    
    for tag in data.series[0].data
      if tag.code != 'missing'
        @serie.classified += tag.y
      else
        @serie.unclassified += tag.y

    total = @serie.classified + @serie.unclassified
    if total > 0
      percentage = (@serie.classified * 100 / total).toFixed()
    else
      percentage = 0

    @$el
      .removeClass('processing')
      .html(I18n.t('monitoring.dashboard.campaign.classified_contents') + ' ' + percentage + '%')

    @trigger('rendered')
